document.addEventListener("DOMContentLoaded", function () {

  // Run only if URL contains /products/
  if (!window.location.pathname.includes("/products/")) return;

  const stitchedSizeWrapper = document.querySelector('.custom-main-sizes');
  const customSizeWrapper = document.querySelector('.custom_size_option_addon');
  const customSizeInputs = customSizeWrapper ? customSizeWrapper.querySelectorAll('input, textarea, select') : [];
  const stitchedRadios = document.querySelectorAll('.custom-main-sizes input[type="radio"]');
  const customSizeRadio = document.getElementById('custom-size');

  function disableElements(elements, state) {
    elements.forEach(el => el.disabled = state);
  }

  function showCustomSizeFields() {
    if (customSizeWrapper) {
      customSizeWrapper.style.display = 'block';
      disableElements(customSizeInputs, false);
    }
  }

  function hideCustomSizeFields() {
    if (customSizeWrapper) {
      customSizeWrapper.style.display = 'none';
      disableElements(customSizeInputs, true);
      customSizeInputs.forEach(input => {
        if (input.type === 'checkbox' || input.type === 'radio') {
          input.checked = false;
        } else {
          input.value = '';
        }
      });
    }
  }

  function toggleElements(type) {
    const isStitched = type === 'stitched';

    if (stitchedSizeWrapper) {
      stitchedSizeWrapper.style.display = isStitched ? 'block' : 'none';
      disableElements(stitchedSizeWrapper.querySelectorAll('input, select'), !isStitched);

      if (!isStitched) {
        // clear stitched sizes + custom size
        stitchedRadios.forEach(radio => (radio.checked = false));
        hideCustomSizeFields();
      } else {
        // Auto select first if none checked
        const checked = [...stitchedRadios].some(radio => radio.checked);
        if (!checked && stitchedRadios.length > 0) {
          stitchedRadios[0].checked = true;
        }

        // If custom size already selected
        if (customSizeRadio && customSizeRadio.checked) {
          showCustomSizeFields();
        } else {
          hideCustomSizeFields();
        }
      }
    }
  }

  function getSelectedVariantType() {
    const variantPicker = document.querySelector('variant-picker');
    if (!variantPicker) return null;
    const variantData = variantPicker.querySelector('script[type="application/json"]');
    if (!variantData) return null;
    try {
      const variant = JSON.parse(variantData.innerHTML || '{}');
      return variant?.options?.[0]?.toLowerCase() || null;
    } catch {
      return null;
    }
  }

  // Initial load
  const initialType = getSelectedVariantType();
  if (initialType) toggleElements(initialType);

  // On variant change
  document.addEventListener('variant:change', function (e) {
    const variant = e.detail.variant;
    if (!variant || !variant.options) return;
    toggleElements(variant.options[0]?.toLowerCase());
  });

  // On stitched radio change
  stitchedRadios.forEach(radio => {
    radio.addEventListener('change', function () {
      if (this.id === 'custom-size') {
        showCustomSizeFields();
      } else {
        hideCustomSizeFields();
      }
    });
  });
});
